import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AiFillStar } from 'react-icons/ai';

import { API_URL } from '../../actions';
import { putFavoritesAction } from '../../actions/userActions';
import styles from './ToolCard.module.scss';

function ToolCard({ tool }) {
  const dispatch = useDispatch();
  const { userAuth } = useSelector((state) => state.auth);
  const isFavorite = Boolean(userAuth?.favoriteTools?.find((t) => t === tool._id));

  function handleChangeFavorite(e) {
    e.preventDefault();
    e.stopPropagation();
    const current = userAuth?.favoriteTools ? [...userAuth.favoriteTools] : [];
    const favoriteTools = isFavorite
      ? current.filter((f) => f !== tool._id)
      : [...current, tool._id];
    if (userAuth?._id) {
      putFavoritesAction(dispatch, { favoriteTools });
    }
  }

  const color = tool.color || '#D0D0D2';
  const imageUrl = tool?.image?.path ? `${API_URL}/${tool.image.path}` : null;
  const iconUrl = tool?.icon?.path ? `${API_URL}/${tool.icon.path}` : null;
  const divisions = (tool.division || []).filter(Boolean);

  return (
    <article className={styles.card}>
      <button
        type="button"
        className={`${styles.favorite} ${isFavorite ? styles.active : ''}`}
        onClick={handleChangeFavorite}
        aria-label={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      >
        <AiFillStar />
      </button>

      <Link to={`/majee/tool/${tool._id}`} className={styles.link}>
        <div className={styles.cover} style={{ backgroundColor: color }}>
          {imageUrl ? <img src={imageUrl} alt="" className={styles.coverImage} /> : null}
        </div>

        <div className={styles.meta}>
          <div className={styles.nameRow}>
            <span className={styles.toolIcon} style={{ backgroundColor: color }}>
              {iconUrl ? <img src={iconUrl} alt="" /> : null}
            </span>
            <span className={styles.toolName}>{tool?.title}</span>
          </div>
          {divisions.length > 0 ? (
            <div className={styles.tags}>
              {divisions.map((d) => (
                <span key={d} className={styles.tag}>{d}</span>
              ))}
            </div>
          ) : null}
        </div>
      </Link>
    </article>
  );
}

export default ToolCard;
